import { MarkdownContent } from "./MarkdownContent";

interface SummaryBlockProps {
  summary: string;
  abstract: string;
}

export function SummaryBlock({ summary, abstract }: SummaryBlockProps) {
  return (
    <div className="space-y-4">
      <div className="relative rounded-2xl bg-highlight-bg p-5 sm:p-6">
        <div className="absolute -top-2.5 left-5 rounded-full bg-white px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-highlight-text shadow-sm ring-1 ring-highlight-border/50">
          AI Summary
        </div>
        <div className="prose prose-slate prose-sm max-w-none text-slate-800 prose-p:leading-relaxed prose-a:text-accent prose-a:no-underline hover:prose-a:underline prose-strong:font-semibold prose-strong:text-slate-900 prose-headings:font-semibold prose-headings:text-slate-900">
          <MarkdownContent content={summary} />
        </div>
      </div>

      <details className="group">
        <summary className="flex cursor-pointer items-center gap-2 pl-1 text-xs font-medium text-slate-400 transition hover:text-slate-600 select-none">
          <svg 
            className="h-3.5 w-3.5 transition-transform duration-200 group-open:rotate-90" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
          显示原始摘要
        </summary>
        <div className="mt-3 animate-fade-in rounded-xl border border-slate-100 bg-white p-4 text-sm leading-relaxed text-slate-600">
          {abstract || "暂无摘要"}
        </div>
      </details>
    </div>
  );
}